import { scope } from '#components/generics/js/selectors/scope.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import skin from '#utilities/js/ea/skin.js'
import { app, web2, junior, kid } from '#utilities/js/ea/skins.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import confirm from '#utilities/js/ea/confirm.js'
import * as menu from '#utilities/js/lightboxes/menus/menu.js'

const skins = [app, web2, junior, kid]

export const onTapUp = object(tapUp, {
  hooks: array([
    preventDefault,
  ]),
  task: async (
    anchor,
    event
  ) => {
    /**
     * @todo HACK: pour supporter les anciens events de drag and drop, notamment pour dropper
     * des éléments vers le menu du disque virtuel et vers le menu du mail
     */
    if (!closest('[onmouseover^="return ea_mouse_drag"]', anchor)) {
      event.stopImmediatePropagation()
    }

    const { dataset, target } = anchor
    const { confirm: message, download } = dataset
    const { href } = anchor
    const list = menu.list(anchor)
    let result = true

    if (message) {
      const { title, text = '' } = JSON.parse(message)
      const openers = [anchor]

      if (list) {
        openers.push(menu.opener(list))
      }

      menu.stash()
      result = await confirm(title, text, openers)
    }

    if (result) {
      if (skins.includes(skin)) {
        if (download) {
          const { url, filename } = scope(anchor)

          if (url && filename) {
            globals.ea_download_add(self.parent.app.downloadMgr, url, filename, true)

            if (list) {
              menu.unstash()
              menu.close()
            }

            return
          }
        } else { // Dans le cas d'une iframe
          if (['app'].includes(skin)) {
            result = globals.ea_link(href, (target === 'popup') ? target : '', null)
          } else {
            result = globals.ea_link(href, (target === '_blank') ? target : '', null)
          }
        }
      }
    }

    requestAnimationFrame(() => {
      if (result) {
        if (list) {
          menu.unstash()
        }

        anchor.click()
      }

      if (list) {
        menu.close()
      }
    })
  }
})

export default anchor => {
  onTapUp.listen(anchor)
}
